import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import Modal from 'react-modal'
import 'moment/locale/de'

require('moment').locale('de')

const root = document.getElementById('root')
Modal.setAppElement(root)

ReactDOM.render(<App />, document.getElementById('root'))
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js